import '../App.css';
import Header from './Component/Header';
import Footer from './Component/Footer';
import React from 'react';
function About() {
  return (
    <>
      <div className='headdddd sticky-top'>
        <div className='header1 '>
          <Header />
        </div>
      </div>
      <div className='backgroundcolorr'>
        <div className='container-fluid'>
          <div className='row '>
            <div className='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12'>
              <div className='myimage text-center mt-5'>
                <img src="/assets/image/MyImage.jpg" alt="myimage" />
              </div>
            </div>
            <div className='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12'>
              <div className='aboutme text-center mt-5'>
                <p className='headingbolddd' >ABOUT ME</p>
                <hr className='horizontallineeeee'></hr><p className='who'>WHO AM I ?</p>
              </div>
              <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'>
                <div className='myworkprofile'>
                  <h3>Front-End Developer</h3>
                </div>
              </div>
              <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'>
                <div className='aboutmeparagraph text-justify mt-3'>
                  <div>
                    <p>Hello! I'm Mohit Negi, a skilled React.js and Front-End Developer with extensive experience in creating user-friendly web applications and responsive designs. I am specialize in designing and implementing intuitive user interfaces and crafting seamless user experiences using modern front-end technologies.</p>
                    <p>With demonstrated expertise in building dynamic websites and web apps, including fintech and loan management solutions, I am passionate about expanding my skill set into back-end development to become a versatile Full-Stack Developer. I am eager to leverage my technical expertise and creative problem-solving skills to contribute to innovative projects and collaborate with forward-thinking tech teams.</p>
                    <p>I graduated with a Bachelor of Computer Applications (BCA) from IP University in 2024 and am currently pursuing a Master of Computer Applications (MCA) from Uttaranchal University, balancing my studies with my professional responsibilities.</p>
                    <p>My journey in the tech world is driven by a commitment to continuous learning and a desire to innovate. I am excited about the opportunities that lie ahead as I work towards becoming a proficient Full-Stack Web Developer.</p>
                  </div>
                </div>
              </div>
              <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'>
                <div className='cvpdff text-right mt-3 mb-5'>
                  <a href="/assets/image/Mohit CV.pdf" target="_blank" rel="My CV">
                    <button className="text-left">DOWNLOAD CV</button>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
              <div className='Education text-center mt-5'>
                <p className='headingbolddd' >EDUCATION</p>
                <hr className='Educationline'></hr><p className='learning'>LEARNING</p>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-5 col-md-5 col-sm-5 col-12 education-section'>
              <div className='row'>
                <div className='col-md-12 col-sm-12 col-12'>
                  <div className='educationbox1'>
                    <div className='col-md-12 col-sm-12 col-12'>
                      <div className='educationyear'>
                        <h1><span className='firstyear'>2024</span>-26</h1>
                      </div>
                    </div>
                    <div className='col-md-12 col-sm-12 col-12'>
                      <div className='educationcourse'>
                        <h4>Master's of Computer Application</h4>
                        <h5>Uttaranchal University (UU)</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='row big'>
                <div className='col-md-12 col-sm-12 col-12'>
                  <div className='educationbox2 mt-5'>
                    <div className='col-md-12 col-sm-12 col-12'>
                      <div className='educationyear'>
                        <h1><span className='firstyear'>2020</span></h1>
                      </div>
                    </div>
                    <div className='col-md-12 col-sm-12 col-12'>
                      <div className='educationcourse'>
                        <h4>Intermediate</h4>
                        <h5>CBSE</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div className='col-md-2 col-sm-2 col-12'>
              <div class="vl"></div>
            </div>
            <div className='col-lg-5 col-md-5 col-sm-5 col-12 education-section'>

              <div className='row'>
                <div className='col-md-12 col-sm-12 col-12'>
                  <div className='educationbox3'>
                    <div className='col-md-12 col-sm-12 col-12'>
                      <div className='educationyear'>
                        <h1><span className='firstyear'>2021</span>-24</h1>
                      </div>
                    </div>
                    <div className='col-md-12 col-sm-12 col-12'>
                      <div className='educationcourse'>
                        <h4>Bachelor's of Computer Application</h4>
                        <h5>Guru Gobind Singh Indraprastha University (IPU)</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='row small'>
                <div className='col-md-12 col-sm-12 col-12' >
                  <div className='educationbox2 mt-5'>
                    <div className='col-md-12 col-sm-12 col-12'>
                      <div className='educationyear'>
                        <h1><span className='firstyear'>2020</span></h1>
                      </div>
                    </div>
                    <div className='col-md-12 col-sm-12 col-12'>
                      <div className='educationcourse'>
                        <h4>Intermediate</h4>
                        <h5>CBSE</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='row'>
                <div className='col-md-12 col-sm-12 col-12'>
                  <div className='educationbox4'>
                    <div className='col-md-12 col-sm-12 col-12'>
                      <div className='educationyear'>
                        <h1><span className='firstyear'>2018</span></h1>
                      </div>
                    </div>
                    <div className='col-md-12 col-sm-12 col-12'>
                      <div className='educationcourse'>
                        <h4>High School</h4>
                        <h5>CBSE</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-12 col-md-12 col-12'>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default About;